import {AccountsService} from "app/account/services/AccountsService";
import {BankAccountTransactionsService} from "./BankAccountTransactionsService";
import {ContractNotesService} from "./ContractNotesService";
import {AccountTransactionsService} from "./AccountTransactionsService";
import {TradingAccountDetailService} from "./TradingAccountDetailService";
import {ChessRegistrationDetailsService} from "./ChessRegistrationDetailsService";
import {AveragePriceUpdateRequestService} from "./AveragePriceUpdateRequestService";
import {AccountManagementService} from "./AccountManagmentService";

export default function() {
    return angular.module("tfApp.account.services", [])
                  .service(AccountsService.id, AccountsService)
                  .service(BankAccountTransactionsService.id, BankAccountTransactionsService)
                  .service(AccountTransactionsService.id, AccountTransactionsService)
                  .service(ContractNotesService.id, ContractNotesService)
                  .service(TradingAccountDetailService.id, TradingAccountDetailService)
                  .service(ChessRegistrationDetailsService.id, ChessRegistrationDetailsService)
                  .service(AveragePriceUpdateRequestService.id, AveragePriceUpdateRequestService)
                  .service(AccountManagementService.id, AccountManagementService)
                  .name;
}
